import 'twin.macro'

import { ThemeContext } from 'contexts/theme-context'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import Caption from '../caption'

function LangToggle() {
  const [lang, setLang] = useState<string | null>(null)
  const { theme } = React.useContext(ThemeContext)

  const { i18n } = useTranslation()
  useLayoutEffect(() => {
    switch (i18n.language) {
      case 'kk':
        setLang('Рус')
        break
      case 'ru':
        setLang('Қаз')
        break
      default:
        break
    }
  }, [i18n.language])

  const toggleLanguage = () => {
    const lang = i18n.language === 'kk' ? 'ru' : 'kk'
    i18n.changeLanguage(lang)
    document.cookie = `django_language=${lang}; max-age=300; path=/;`
    sessionStorage.setItem('django_language', lang)
  }

  useEffect(() => {
    if (!sessionStorage.getItem('django_language')) {
      if (i18n.language.includes('ru')) {
        document.cookie = `django_language=ru; max-age=300; path=/;`
        sessionStorage.setItem('django_language', 'ru')
      } else {
        document.cookie = `django_language=kk; max-age=300; path=/;`
        sessionStorage.setItem('django_language', 'kk')
      }
    } else {
      document.cookie = `django_language=${sessionStorage.getItem('django_language')}; max-age=300; path=/;`
    }
  }, [])

  return (
    <button
      tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-tertiary rounded-full cursor-pointer'
      onClick={toggleLanguage}
      css={[theme === 'dark' ? tw`text-white` : tw`text-[#636366]`]}
    >
      <Caption>{lang}</Caption>
    </button>
  )
}

export default LangToggle
